import { render, staticRenderFns } from "./v-modal.vue?vue&type=template&id=1cf5167d&scoped=true&"
import script from "./v-modal.vue?vue&type=script&lang=js&"
export * from "./v-modal.vue?vue&type=script&lang=js&"
import style0 from "./v-modal.vue?vue&type=style&index=0&id=1cf5167d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf5167d",
  null
  
)

export default component.exports